import { c as _c } from "react/compiler-runtime";
import { FormSelect, FormSelectDataType, Hint } from '@systemeio/ui';
import React from 'react';
import { SectionMessage } from 'shared/components/section-message';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import { WebsiteErrorsInterface } from '../types/website-interface';
import { SectionErrorsPathList } from './section-errors-path-list';
interface FormSelectUserDomainWithWebsiteProps {
  value: number | null;
  onChange: (value: number | null) => void;
  errors: WebsiteErrorsInterface;
  data: FormSelectDataType<number>[] | undefined;
  isDomainOccupied: boolean;
  prevDomainId?: number | null;
}
export const FormSelectUserDomainWithWebsite = t0 => {
  const $ = _c(25);
  const {
    value,
    onChange,
    errors,
    data,
    prevDomainId
  } = t0;
  const {
    t
  } = useLocoTranslation();
  let t1;
  if ($[0] !== onChange) {
    t1 = value_0 => onChange(value_0 ?? null);
    $[0] = onChange;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const t2 = value ?? undefined;
  let t3;
  if ($[2] !== t) {
    t3 = t("dashboard.website.create_checkbox_hint");
    $[2] = t;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t) {
    t4 = t("dashboard.website.domain_name");
    $[4] = t;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t3 || $[7] !== t4) {
    t5 = <Hint label={t3}>{t4}</Hint>;
    $[6] = t3;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== data || $[10] !== errors.domainId || $[11] !== t1 || $[12] !== t2 || $[13] !== t5) {
    t6 = <FormSelect key="website-domain-create" onChange={t1} value={t2} label={t5} data={data} error={errors.domainId} />;
    $[9] = data;
    $[10] = errors.domainId;
    $[11] = t1;
    $[12] = t2;
    $[13] = t5;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== prevDomainId || $[16] !== t || $[17] !== value) {
    t7 = value === null && !!prevDomainId && <SectionMessage>{t("dashboard.website.warring_info_deactivate")}</SectionMessage>;
    $[15] = prevDomainId;
    $[16] = t;
    $[17] = value;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  let t8;
  if ($[19] !== errors.path) {
    t8 = errors.path && <SectionErrorsPathList error={errors.path.split("\n")} />;
    $[19] = errors.path;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  let t9;
  if ($[21] !== t6 || $[22] !== t7 || $[23] !== t8) {
    t9 = <div className="flex flex-col gap-2">{t6}{t7}{t8}</div>;
    $[21] = t6;
    $[22] = t7;
    $[23] = t8;
    $[24] = t9;
  } else {
    t9 = $[24];
  }
  return t9;
};